/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceObjectAreaV1Dto } from './ServiceObjectAreaV1Dto';
import type { ServiceObjectDocumentV1Dto } from './ServiceObjectDocumentV1Dto';
import type { ServiceObjectPartnerRelationShortV1Dto } from './ServiceObjectPartnerRelationShortV1Dto';
import type { ServiceObjectPosV1Dto } from './ServiceObjectPosV1Dto';
import type { ServiceObjectStatusV1Dto } from './ServiceObjectStatusV1Dto';
import type { ServiceObjectTicketV1Dto } from './ServiceObjectTicketV1Dto';
import type { ServiceObjectTypeV1Dto } from './ServiceObjectTypeV1Dto';
import type { SimpleCustomerV1Dto } from './SimpleCustomerV1Dto';
export type ServiceObjectV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Comments related to the service object
   */
  comments?: string;
  /**
   * Construction year of the service object
   */
  constructionYear?: number;
  /**
   * Inventory number of the service object
   */
  inventoryNumber?: string;
  /**
   * Manufacturer of the service object
   */
  manufacturer: string;
  /**
   * Model of the service object
   */
  model: string;
  /**
   * Name of the service object
   */
  name: string;
  /**
   * Responsibility of the service object
   */
  responsibleRole: ServiceObjectV1Dto.responsibleRole;
  /**
   * Serial number of the service object
   */
  serialNumber?: string;
  /**
   * Area associated with the service object
   */
  area: ServiceObjectAreaV1Dto;
  /**
   * Customer associated with the service object
   */
  customer: SimpleCustomerV1Dto;
  /**
   * Documents related to the service object
   */
  documents?: Array<ServiceObjectDocumentV1Dto>;
  /**
   * Maintenance statuses related to the service object
   */
  maintenanceStatuses: Array<ServiceObjectStatusV1Dto>;
  /**
   * deadlines related to the service object
   */
  deadlines: Array<ServiceObjectStatusV1Dto>;
  /**
   * Partners associated with the service object
   */
  partners?: Array<ServiceObjectPartnerRelationShortV1Dto>;
  /**
   * Point of sale associated with the service object
   */
  pointOfSale?: ServiceObjectPosV1Dto;
  /**
   * Tickets related to the service object
   */
  tickets?: Array<ServiceObjectTicketV1Dto>;
  /**
   * Type associated with the service object
   */
  type?: ServiceObjectTypeV1Dto;
};
export namespace ServiceObjectV1Dto {
  /**
   * Responsibility of the service object
   */
  export enum responsibleRole {
    CUSTOMER = 'Customer',
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
